import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import styled from "styled-components";
import {
    SwapStationsButtonBaseBox,
    SwapStationsChevronIconWrapperBox
} from "../boxes/swap-stations-button.base-boxes";
import {ChevronForwardIcon} from "../../../../assets/svg/chevron-forward.icon";
import {ChevronBackIcon} from "../../../../assets/svg/chevron-back.icon";

const SwapStationsButtonBox = styled(SwapStationsButtonBaseBox)`
    flex-direction: column;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    cursor: pointer;
    padding: 11px 6px;
    
`


export const SearchMaskSwapStationsButtonLargeScreenComponent: React.FC = observer(() => {
    const services = useServices();
    return (
        <SwapStationsButtonBox onClick={() => services.flightSearch.switchStations()}>
            <SwapStationsChevronIconWrapperBox>
                <ChevronForwardIcon/>
            </SwapStationsChevronIconWrapperBox>
            <SwapStationsChevronIconWrapperBox>
                <ChevronBackIcon/>
            </SwapStationsChevronIconWrapperBox>
        </SwapStationsButtonBox>
    )
})